export default {
  GET_FEEDBACK: 'GET_FEEDBACK',
  RESPOND_TO_FEEDBACK: 'RESPOND_TO_FEEDBACK',
  MARK_FEEDBACK_RESOLVED: 'MARK_FEEDBACK_RESOLVED'
}
